import axios from 'axios'
import appConfig from '@/service/config'
import userService from '@/service/userService'
import MainPresenter from "@/service/MainPresenter"
import un from 'underscore'
import moment from 'moment'

const mainPresenter = new MainPresenter();

let guid = () => {
    let s4 = () => {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

function mapRules(rulesReponse) {
    const rules = []
    for (var productName in rulesReponse.rules) {
        var categories = rulesReponse.rules[productName]
        rules.push(
            {
                id: guid(),
                productName: productName,
                category: categories[0]
            }
        )
    }
    return rules
}

function removeConstraint(rules, item) {
    const itemToDelete = un.findWhere(rules, {
        id: item.id
    })
    return un.without(rules, itemToDelete);
}

function addNewConstraint(rules) {
    rules.push(
        {
            id: guid(),
            productName: "",
            category: {
                id: -1,
                name: ""
            }
        }
    )
    return rules
}

function fetchConstraints(onSuccess, onError) {
  const req =  axios({
     method: 'get',
     url: appConfig.baseUrl + '/categoryConstraints',
     headers: {
       Authorization: userService.getAuthHeader()
     }
   })
   req.then(res => {
        onSuccess(res.data)
    }).catch(e => {
        onError(e)
    })
}

function mapToRequestConstraints(rulesData) {
    const rules = {}
    for (var i in rulesData) {
        var item = rulesData[i]
        rules[item.productName] = [item.category.id]
    }
    return rules
}

function saveConstraints(data, onSuccess, onError) {
    const req =  axios({
       method: 'post',
       data: data,
       url: appConfig.baseUrl + '/categoryConstraints',
       headers: {
         Authorization: userService.getAuthHeader()
       }
     })
     req.then(res => {
          onSuccess(res.data)
      }).catch(e => {
          onError(e)
      })
  }

function fetchAllCategories(onSuccess, onError) {
    var pageable =  appConfig.pageableMainParams
    pageable.sort = "name,asc"
    const req = axios({
        method: 'get',
        url: mainPresenter.getUrlForCommonData("/categories/", {}, pageable),
        headers: {
            Authorization: userService.getAuthHeader()
        }
    })
    req.then(res => {
        onSuccess(res.data._embedded.categories)
    }).catch(err => {
        onError(err)
    })
}

function searchProductNames(query, onSuccess, onError) {
    const req =  axios({
        method: 'post',
        data: { "query": query },
        url: appConfig.baseUrl + '/categoryConstraints/searchNames',
        headers: {
          Authorization: userService.getAuthHeader()
        }
      })
      req.then(res => {
           onSuccess(res.data)
       }).catch(e => {
           onError(e)
       })
}

function deleteConstraints(id, onSuccess, onError) {
    const req =  axios({
        method: 'delete',
        url: appConfig.baseUrl + '/categoryConstraints/' + id,
        headers: {
          Authorization: userService.getAuthHeader()
        }
      })
      req.then(res => {
           onSuccess(res.data)
       }).catch(e => {
           onError(e)
       })
}

export default {
    "fetchConstraints": fetchConstraints,
    "fetchAllCategories": fetchAllCategories,
    "saveConstraints": saveConstraints,
    "removeConstraint": removeConstraint,
    "addNewConstraint": addNewConstraint,
    "searchProductNames": searchProductNames,
    "deleteConstraints": deleteConstraints
}


// WEBPACK FOOTER //
// ./src/components/category-constraints/CategoryConstraintsService.js